import {
  DashboardOutlined,
  UserOutlined,
  SafetyCertificateOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  TrophyOutlined,
  BarChartOutlined,
  SettingOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  TableOutlined,
  AppstoreOutlined,
  IdcardOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
  ScheduleOutlined,
  ApartmentOutlined,
  SafetyOutlined,
  GiftOutlined,
  StopOutlined,
  ThunderboltOutlined,
  CheckSquareOutlined,
  ScanOutlined,
  FileSearchOutlined,
  EnvironmentOutlined,
  QrcodeOutlined,
  CameraOutlined,
  FundOutlined,
  ToolOutlined,
  CheckCircleOutlined,
  OrderedListOutlined,
  WalletOutlined,
  FileDoneOutlined,
  SwapOutlined,
  SyncOutlined,
  PieChartOutlined,
  ProfileOutlined,
  BankOutlined,
  CalculatorOutlined,
  LaptopOutlined,
  StarOutlined,
  MessageOutlined,
  ReadOutlined,
  UsergroupAddOutlined,
  ShopOutlined,
  VideoCameraOutlined
} from '@ant-design/icons';

const dashboard = {
  id: 'group-dashboard',
  title: 'HRMS',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: DashboardOutlined
    },
    {
      id: 'employee',
      title: 'Employee',
      type: 'item',
      url: '/employees/employee',
      icon: UserOutlined,
    },
    {
      id: 'enterprise',
      title: 'Enterprise',
      type: 'collapse',
      icon: FileSearchOutlined,
      children: [
        { id: 'enterprise-reports', title: 'Control Center', type: 'item', url: '/enterprise/reports', icon: FundOutlined },
        { id: 'enterprise-audit', title: 'Audit Trail', type: 'item', url: '/enterprise/audit', icon: FileSearchOutlined }
      ]
    },
    {
      id: 'attendance',
      title: 'Attendance',
      type: 'collapse',
      icon: ClockCircleOutlined,
      children: [
        { id: 'att-dashboard', title: 'Dashboard', type: 'item', url: '/attendance/dashboard', icon: AppstoreOutlined },
        { id: 'att-list', title: 'Attendance List', type: 'item', url: '/attendance/list', icon: UnorderedListOutlined },
        { id: 'att-work-records', title: 'Work Records', type: 'item', url: '/attendance/work-records', icon: TableOutlined },
        { id: 'att-my', title: 'My Attendance', type: 'item', url: '/attendance/my-attendance', icon: IdcardOutlined },
        { id: 'att-regularize', title: 'Regularization', type: 'item', url: '/attendance/regularization', icon: EditOutlined },
        // { id: 'att-missing', title: 'Missing Punch', type: 'item', url: '/attendance/missing-punch', icon: ExclamationCircleOutlined },
        { id: 'att-wfh', title: 'Work From Home', type: 'item', url: '/attendance/work-from-home', icon: LaptopOutlined },
        { id: 'att-bulk', title: 'Bulk Upload', type: 'item', url: '/attendance/bulk-upload', icon: UploadOutlined },
        { id: 'att-shift', title: 'Shift Management', type: 'item', url: '/attendance/shift-management', icon: ScheduleOutlined },
        { id: 'att-policy', title: 'Attendance Policy', type: 'item', url: '/attendance/policy', icon: SafetyOutlined },
        { id: 'att-weekly-off', title: 'Weekly Off', type: 'item', url: '/attendance/weekly-off', icon: StopOutlined },
        { id: 'att-overtime', title: 'Overtime', type: 'item', url: '/attendance/overtime', icon: ThunderboltOutlined },
        { id: 'att-approval', title: 'Attendance Approval', type: 'item', url: '/attendance/approval', icon: CheckSquareOutlined },
        { id: 'att-reports', title: 'Reports', type: 'item', url: '/attendance/reports', icon: FundOutlined },
        { id: 'att-settings', title: 'Settings', type: 'item', url: '/attendance/settings', icon: ToolOutlined },
      ]
    },
    {
      id: 'leaves',
      title: 'Leaves',
      type: 'collapse',
      icon: CalendarOutlined,
      children: [
        { id: 'leave-dashboard', title: 'Dashboard', type: 'item', url: '/leave/dashboard', icon: AppstoreOutlined },
        { id: 'leave-applications', title: 'Leaves Request', type: 'item', url: '/leave/applications', icon: OrderedListOutlined },
        { id: 'leave-approval', title: 'Leave Approval', type: 'item', url: '/leave/approval', icon: CheckCircleOutlined },
        { id: 'leave-types', title: 'Leave Types', type: 'item', url: '/leave/types', icon: TableOutlined },
        { id: 'leave-balance', title: 'Leave Balance', type: 'item', url: '/leave/balance', icon: WalletOutlined },
        { id: 'leave-policy', title: 'Leave Policy', type: 'item', url: '/leave/policy', icon: SafetyOutlined },
        { id: 'leave-holiday', title: 'Holiday Calendar', type: 'item', url: '/leave/holiday-calendar', icon: GiftOutlined },
        { id: 'leave-recurrence', title: 'Recurrence Master', type: 'item', url: '/leave/recurrence-master', icon: SyncOutlined },
        { id: 'leave-comp-off', title: 'Compensatory Off', type: 'item', url: '/leave/comp-off', icon: SwapOutlined },
        { id: 'leave-encashment', title: 'Leave Encashment', type: 'item', url: '/leave/encashment', icon: DollarOutlined },
        { id: 'leave-reports', title: 'Reports', type: 'item', url: '/leave/reports', icon: PieChartOutlined },
      ]
    },
    {
      id: 'payroll',
      title: 'Payroll',
      type: 'collapse',
      url: '/payroll/dashboard',
      icon: DollarOutlined,
      children: [
        { id: 'payroll-dashboard', title: 'Dashboard', type: 'item', url: '/payroll/dashboard', icon: AppstoreOutlined },
        { id: 'client-staff-payroll', title: 'Client-Side Staff', type: 'item', url: '/payroll/client-staff', icon: TeamOutlined },
        { id: 'payroll-run', title: 'Run Payroll', type: 'item', url: '/payroll/run', icon: CalculatorOutlined },
        { id: 'payroll-salary', title: 'Salary Structure', type: 'item', url: '/payroll/salary-structure', icon: ProfileOutlined },
        { id: 'payroll-employee-payroll', title: 'Employee Payroll', type: 'item', url: '/payroll/employee-payroll', icon: WalletOutlined },
        { id: 'payroll-expense-claims', title: 'Expense Claims', type: 'item', url: '/expenses/claims', icon: OrderedListOutlined },
        { id: 'payroll-expense-approvals', title: 'Expense Approvals', type: 'item', url: '/expenses/approvals', icon: CheckCircleOutlined },
        { id: 'payroll-company-expenses', title: 'Company Expenses (OpEx)', type: 'item', url: '/expenses/company-expenses', icon: BankOutlined },
        { id: 'payroll-payslips', title: 'Payslips', type: 'item', url: '/payroll/payslips', icon: FileDoneOutlined },
        { id: 'payroll-reports', title: 'Reports', type: 'item', url: '/payroll/reports', icon: BankOutlined },
      ]
    },
    {
      id: 'projects',
      title: 'Project Management',
      type: 'collapse',
      url: '/projects/dashboard',
      icon: ApartmentOutlined,
      children: [
        { id: 'project-dashboard', title: 'Executive Dashboard', type: 'item', url: '/projects/dashboard', icon: FundOutlined },
        { id: 'project-list', title: 'Projects', type: 'item', url: '/projects/list', icon: UnorderedListOutlined },
        { id: 'project-clients', title: 'Client Master', type: 'item', url: '/projects/clients', icon: TeamOutlined },
        { id: 'project-tasks', title: 'Tasks', type: 'item', url: '/projects/tasks', icon: CheckSquareOutlined },
        { id: 'project-milestones', title: 'Milestones', type: 'item', url: '/projects/milestones', icon: ScheduleOutlined },
        { id: 'project-reviews', title: 'Reviews & QA', type: 'item', url: '/projects/reviews', icon: FileDoneOutlined },
        { id: 'project-resources', title: 'Resource Planning', type: 'item', url: '/projects/resources', icon: TeamOutlined },
        { id: 'project-risks', title: 'Risks & Escalations', type: 'item', url: '/projects/risks', icon: ExclamationCircleOutlined },
        { id: 'project-timesheets', title: 'Timesheets', type: 'item', url: '/projects/timesheets', icon: ClockCircleOutlined },
        { id: 'project-reports', title: 'Reports', type: 'item', url: '/projects/reports', icon: PieChartOutlined },
        { id: 'project-analytics', title: 'Analytics & Delivery', type: 'item', url: '/projects/analytics', icon: BarChartOutlined },
      ]
    },
    {
      id: 'assets',
      title: 'Assets Management',
      type: 'collapse',
      url: '/assets/dashboard',
      icon: LaptopOutlined,
      children: [
        { id: 'assets-dashboard', title: 'Dashboard', type: 'item', url: '/assets/dashboard', icon: AppstoreOutlined },
        { id: 'assets-list', title: 'Assets Register', type: 'item', url: '/assets/list', icon: UnorderedListOutlined },
        { id: 'assets-assignments', title: 'Assignments', type: 'item', url: '/assets/assignments', icon: CheckSquareOutlined },
        { id: 'assets-requests', title: 'Asset Requests', type: 'item', url: '/assets/requests', icon: FileSearchOutlined },
        { id: 'assets-stock', title: 'Stock & Inventory', type: 'item', url: '/assets/stock', icon: TableOutlined },
        { id: 'assets-depreciation', title: 'Depreciation Books', type: 'item', url: '/assets/depreciation', icon: CalculatorOutlined },
        { id: 'assets-maintenance', title: 'Maintenance', type: 'item', url: '/assets/maintenance', icon: ToolOutlined },
        { id: 'assets-procurement', title: 'Vendors & Purchases', type: 'item', url: '/assets/procurement', icon: ShopOutlined },
        { id: 'assets-reports', title: 'Reports', type: 'item', url: '/assets/reports', icon: PieChartOutlined },
      ]
    },
    {
      id: 'virtual-meetings',
      title: 'Virtual Meetings',
      type: 'item',
      url: '/meetings',
      icon: VideoCameraOutlined
    },
    {
      id: 'performance',
      title: 'Performance',
      type: 'collapse',
      url: '/performance/dashboard',
      icon: TrophyOutlined,
      children: [
        { id: 'performance-dashboard', title: 'Dashboard', type: 'item', url: '/performance/dashboard', icon: AppstoreOutlined },
        { id: 'performance-goals', title: 'Goals & OKR', type: 'item', url: '/performance/goals', icon: CheckSquareOutlined },
        { id: 'performance-reviews', title: 'Reviews', type: 'item', url: '/performance/reviews', icon: FileDoneOutlined },
        { id: 'performance-feedback', title: 'Feedback', type: 'item', url: '/performance/feedback', icon: MessageOutlined },
        { id: 'performance-appraisals', title: 'Appraisals', type: 'item', url: '/performance/appraisals', icon: StarOutlined },
        { id: 'performance-reports', title: 'Reports', type: 'item', url: '/performance/reports', icon: PieChartOutlined },
      ]
    },
    {
      id: 'recruitment',
      title: 'Recruitment',
      type: 'collapse',
      url: '/recruitment/dashboard',
      icon: TeamOutlined,
      children: [
        { id: 'recruitment-dashboard', title: 'Dashboard', type: 'item', url: '/recruitment/dashboard', icon: AppstoreOutlined },
        { id: 'recruitment-jobs', title: 'Jobs', type: 'item', url: '/recruitment/jobs', icon: ApartmentOutlined },
        { id: 'recruitment-candidates', title: 'Candidates', type: 'item', url: '/recruitment/candidates', icon: TeamOutlined },
        { id: 'recruitment-interviews', title: 'Interviews', type: 'item', url: '/recruitment/interviews', icon: CalendarOutlined },
        { id: 'recruitment-reports', title: 'Reports', type: 'item', url: '/recruitment/reports', icon: PieChartOutlined },
      ]
    },
    {
      id: 'courses',
      title: 'Learning & Development',
      type: 'collapse',
      url: '/courses/dashboard',
      icon: ReadOutlined,
      children: [
        { id: 'course-dashboard', title: 'LMS Dashboard', type: 'item', url: '/courses/dashboard', icon: AppstoreOutlined },
        { id: 'course-master', title: 'Course Master', type: 'item', url: '/courses/master', icon: ReadOutlined },
        { id: 'course-assignments', title: 'Assignments', type: 'item', url: '/courses/assignments', icon: TeamOutlined },
        { id: 'course-approvals', title: 'Certificate Approvals', type: 'item', url: '/courses/certificate-approvals', icon: CheckSquareOutlined },
        { id: 'course-sessions', title: 'Training Sessions', type: 'item', url: '/courses/training-sessions', icon: CalendarOutlined },
        { id: 'course-reports', title: 'Reports', type: 'item', url: '/courses/reports', icon: PieChartOutlined },
        { id: 'course-my', title: 'My Courses', type: 'item', url: '/courses/my-courses', icon: IdcardOutlined },
      ]
    },
    {
      id: 'user-management',
      title: 'User Management',
      type: 'collapse',
      icon: SafetyCertificateOutlined,
      children: [
        { id: 'um-users', title: 'Users', type: 'item', url: '/user-management/users', icon: UserOutlined },
        { id: 'um-roles', title: 'Roles', type: 'item', url: '/user-management/roles', icon: TeamOutlined },
        { id: 'um-permissions', title: 'Permissions', type: 'item', url: '/user-management/permissions', icon: SafetyCertificateOutlined }
      ]
    },
    {
      id: 'um-workflows',
      title: 'Approval Workflows',
      type: 'item',
      url: '/user-management/approval-workflows',
      icon: SafetyOutlined
    },
    {
      id: 'system-config',
      title: 'System Configuration',
      type: 'collapse',
      icon: SettingOutlined,
      children: [
        { id: 'sc-company', title: 'Companies', type: 'item', url: '/system-config/company', icon: BankOutlined },
        { id: 'sc-branch', title: 'Branches', type: 'item', url: '/system-config/company-branch', icon: ApartmentOutlined },
        { id: 'sc-department', title: 'Department', type: 'item', url: '/system-config/department', icon: TeamOutlined },
        { id: 'sc-designation', title: 'Designation', type: 'item', url: '/system-config/designation', icon: UsergroupAddOutlined },
      ]
    }
  ]
};

export default dashboard;
